import { useState, useEffect } from 'react';
import { Menu, X, Code, Info, Briefcase, BookOpen, Home } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import LanguageSelector from './LanguageSelector';
import './Navbar.css';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  const menuItems = [
    {
      name: 'Inicio',
      icon: Home,
      link: '/',
      type: 'link'
    },
    {
      name: 'Servicios',
      icon: Code,
      link: '/servicios',
      type: 'link'
    },
    {
      name: 'Sobre Nosotros',
      icon: Info,
      link: '/sobre-nosotros',
      type: 'link'
    },
    {
      name: 'Cómo Trabajamos',
      icon: Briefcase,
      link: '/como-trabajamos',
      type: 'link'
    },
    {
      name: 'Blog',
      icon: BookOpen,
      link: '/blog',
      type: 'link'
    }
  ];

  return (
    <nav className={`navbar ${isScrolled ? 'navbar-scrolled' : ''}`}>
      <div className="navbar-container">
        {/* Logo + Nombre */}
        <Link to="/" className="logo-link">
          <img 
            src="/images/logoVaporDesignsSolutions-removebg-preview.png" 
            alt="Vapor Designs Solutions" 
            className="navbar-logo"
          />
          <div className="logo-text">
            <div className="logo-brand">Vapor Designs</div>
            <div className="logo-tagline">Digital Solutions</div>
          </div>
        </Link>

        <div className="flex items-center gap-3">
          {/* Language Selector */}
          <LanguageSelector />
          
          {/* Hamburger Button */}
          <button
            className="hamburger-btn"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Slide Menu */}
      <div className={`slide-menu ${isMenuOpen ? 'slide-menu-open' : ''}`}>
        <div className="slide-menu-content">
          {menuItems.map((item, index) => (
            <div key={index} className="menu-item">
              <Link 
                to={item.link} 
                className="menu-link"
                onClick={() => setIsMenuOpen(false)}
              >
                <item.icon size={20} />
                <span>{item.name}</span>
                {item.badge && <span className="menu-badge">{item.badge}</span>}
              </Link>
            </div>
          ))}
        </div>
      </div>

      {/* Overlay */}
      {isMenuOpen && (
        <div 
          className="menu-overlay" 
          onClick={() => setIsMenuOpen(false)}
        />
      )}
    </nav>
  );
};

export default Navbar;